import React from "react";

/**
 * Nailed wordmark — the letter I is a driven finishing nail.
 * letterColor defaults to currentColor so you can set it with a text color class
 * (e.g. text-white in the nav, text-primary on light grounds).
 * nailColor defaults to the site accent (#f37022).
 *
 * Set in Saira Condensed 800 with a condensed sans fallback.
 */
export default function NailedLogo({
  className = "",
  letterColor = "currentColor",
  nailColor = "#f37022",
}) {
  return (
    <svg
      className={className}
      viewBox="0 0 384 150"
      role="img"
      aria-label="Nailed"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        fontFamily="'Saira Condensed','Arial Narrow',sans-serif"
        fontWeight="800"
        fontSize="120"
        fill={letterColor}
      >
        <text textAnchor="end" x="156" y="116">
          NA
        </text>
        <text textAnchor="start" x="196" y="116">
          LED
        </text>
      </g>
      <g fill={nailColor} transform="translate(159 1)">
        <rect x="7" y="30" width="20" height="10" rx="2" />
        <path d="M9 40 H25 V101 L17 120 L9 101 Z" />
      </g>
    </svg>
  );
}
